import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

/**
 * There is no native support for gratient in borders.
 * We draw box below another box with 1px sides gap.
 *
 * Note: Purple was from #8f00ff to #fd0598
 */
const Wrap = styled.div<{ $inline: boolean }>`
  ${({ $inline }) => ($inline ? `display: inline-block` : 'width: 100%')};
  border: none;
  border-radius: 5px;
  background: linear-gradient(to right, #f63f1c, var(--yellowMain));
  padding: 1px;
`;

const Inner = styled.div`
  background-color: var(--black);
  border-radius: 5px;
`;

export const purpleGradientTextCss = css`
  fill: linear-gradient(
    270deg,
    #f63f1c -9.74%,
    var(--yellowMain) 102.25%,
    var(--yellowMain) 102.26%
  );
  background: linear-gradient(
    270deg,
    #f63f1c -9.74%,
    var(--yellowMain) 102.25%,
    var(--yellowMain) 102.26%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;

export function GradientBox({
  children,
  inline,
}: {
  children: ReactNode;
  inline?: boolean;
}) {
  return (
    <Wrap $inline={!!inline}>
      <Inner>{children}</Inner>
    </Wrap>
  );
}
